import FilterNetworkDropdown from './FilterNetworkDropDown';
import { Button } from '@/components/ui/button';
import { Filter } from 'lucide-react';
import FilterTimeFrameSelector from './FilterTimeFrameSelector';
import { TimeFrames } from '@shared/types/frontend/searchHome';
import { useLocalStorage } from 'usehooks-ts';
interface DFiltersControllerProps {
  setNetwork: (_: number[]) => void;
  network: number[];
  defaultNetwork: number[];
  timeFrame: TimeFrames;
  setTimeFrame: (_: TimeFrames) => void;
  customHandler?: boolean;
}
const DFiltersController = ({
  network,
  defaultNetwork,
  setNetwork,
  timeFrame,
  setTimeFrame,
  customHandler
}: DFiltersControllerProps) => {
  const [wildWest, showWildWest] = useLocalStorage('Wild West-categories', false);
  return <div className='w-fit h-[40px] flex gap-2 items-center bg-genius-indigo rounded-full px-[5px] py-[10px] ' data-sentry-component="DFiltersController" data-sentry-source-file="DFiltersController.tsx">
      <FilterNetworkDropdown setNetwork={setNetwork} network={network} defaultNetwork={defaultNetwork} customHandler={customHandler} data-sentry-element="FilterNetworkDropdown" data-sentry-source-file="DFiltersController.tsx" />
      <FilterTimeFrameSelector timeFrame={timeFrame} setTimeFrame={setTimeFrame} customHandler={customHandler} data-sentry-element="FilterTimeFrameSelector" data-sentry-source-file="DFiltersController.tsx" />
      {wildWest && false && <Button variant='blue' className='flex gap-2 items-center rounded-full w-[84px] h-[32px] px-[7px] py-[3px]'>
          <p>Filters</p>
          <Filter className='w-[12px] h-[12px]' />
        </Button>}
    </div>;
};
export default DFiltersController;